var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentPage < _vm.totalPages)?_c('Button',{staticClass:"mt-10 py-3 mb-28",attrs:{"type":"secondary","text":_vm.$t('Load more')},on:{"click":_vm.onLoadMore}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }